"use client";

import { c as _c } from "react/compiler-runtime";
import MarketplaceItemPreviewCard from "../MarketplaceItemPreviewCard";
import MarketplacePreviewPlaceholder from "./MarketplacePreviewPlaceholder";
import MarketplaceUnavailableCard from "./MarketplaceUnavailableCard";
import type { MarketplaceTypePreviewProps } from "./common";
import { useMarketplacePreviewState } from "./useMarketplacePreviewState";
export default function MarketplaceOpenseaAssetPreview(t0) {
  const $ = _c(20);
  const {
    href,
    compact: t1
  } = t0;
  const compact = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== href) {
    t2 = {
      href,
      mode: "opensea-sanitized"
    };
    $[0] = href;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const state = useMarketplacePreviewState(t2);
  if (state.href !== href || state.type === "loading") {
    let t3;
    if ($[2] !== compact || $[3] !== href) {
      t3 = <MarketplacePreviewPlaceholder href={href} compact={compact} />;
      $[2] = compact;
      $[3] = href;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (state.type === "error") {
    let t3;
    if ($[5] !== compact || $[6] !== href) {
      t3 = <MarketplaceUnavailableCard href={href} compact={compact} />;
      $[5] = compact;
      $[6] = href;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  const media = state.resolvedMedia;
  if (media) {
    let t3;
    if ($[8] !== compact || $[9] !== href || $[10] !== media.mimeType || $[11] !== media.url || $[12] !== state.resolvedDataHealth || $[13] !== state.resolvedPrice || $[14] !== state.resolvedPriceCurrency || $[15] !== state.resolvedTitle) {
      t3 = <MarketplaceItemPreviewCard href={href} mediaUrl={media.url} mediaMimeType={media.mimeType} price={state.resolvedPrice} priceCurrency={state.resolvedPriceCurrency} title={state.resolvedTitle} dataHealth={state.resolvedDataHealth} compact={compact} hideActions={compact} />;
      $[8] = compact;
      $[9] = href;
      $[10] = media.mimeType;
      $[11] = media.url;
      $[12] = state.resolvedDataHealth;
      $[13] = state.resolvedPrice;
      $[14] = state.resolvedPriceCurrency;
      $[15] = state.resolvedTitle;
      $[16] = t3;
    } else {
      t3 = $[16];
    }
    return t3;
  }
  let t3;
  if ($[17] !== compact || $[18] !== href) {
    t3 = <MarketplaceUnavailableCard href={href} compact={compact} />;
    $[17] = compact;
    $[18] = href;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  return t3;
}